import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Field } from 'react-formality'
import { TextField } from '@material-ui/core'

import connectPropTypes from './utilities/connectPropTypes'
import handlerToCallUpdateIfValid from './utilities/Data/handlerToCallUpdateIfValid'
import getField from './utilities/Data/getField'
import Form from './components/Form'
import getFieldValueInUnit from './utilities/Data/User/getFieldValueInUnit'
import Img from './components/Img'
import DistanceUnitField from './components/Edit/DistanceUnitField'

import editStyles from './Edit.icss'

class EditChest extends React.Component {
	constructor(props) {
		super(props)

		this.handlerToCallStatisticsUpdateIfValid = handlerToCallUpdateIfValid(props.userProfileStatisticsUpdate, { history: props.history })
		this.form = React.createRef()
		this.inputRef = React.createRef()
		this.scrollTimeout = null

		props.appShowBottomBar(false)
		props.appShowBottomNavBar(true)
		props.appBottomNavBarHandleClick(() => this.form.current.submit())
	}

	componentDidMount() {
		this.props.appHeading({ text: this.context.translate('Chest measurement') })
		this.props.appBottomNavBarLabelNext(this.context.translate('Done'))
	}

	render() {
		if (!this.props.user.userProfile) {
			return null
		}

		const statistics = getField(this.props.user, 'userProfile.statistics')

		return (
			<section>
				<div className={editStyles.pagePadding}>
					<Form
						ref={this.form}
						onSubmit={({ values, isValid }) => isValid && this.props.userProfileStatisticsUpdate({ values, goBack: true, history: this.props.history })}
						className={classNames(editStyles.oneColumn)}
						initialValues={{
							chest: getFieldValueInUnit(statistics, 'chest') || '',
							chestUnit: getField(statistics, 'chest.unit') || 'cm'
						}}
					>
						{(props) => {
							if (props.isValid === false) {
								this.inputRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' })
							}
							const handlerToCallStatisticsUpdateIfValid = this.handlerToCallStatisticsUpdateIfValid(props.store)
							return (
								<React.Fragment>
									<h2>{this.context.translate('Measure your chest')}</h2>
									<Img content="/images/content/guide/chest.svg" className={editStyles.img} />
									<p>
										{this.context.translate('Measure all the way around the chest at the fullest point under your arm pits.')}
									</p>
									<p>
										{this.context.translate('Alternatively give us the chest measurement of your favourite dress shirt (or bra measurement for women)')}
									</p>
									<div className={editStyles.statistic}>
										<Field
											component={TextField}
											inputRef={this.inputRef}
											name="chest"
											className={editStyles.statisticValue}
											placeholder={props.values.chestUnit}
											label={this.context.translate('Chest')}
											value={props.values.chest}
											type="number"
											onBlur={handlerToCallStatisticsUpdateIfValid('chest', 'chestUnit')}
											validate={{
												presence: true,
												numericality: true
											}}
										/>
										<DistanceUnitField
											name="chestUnit"
											value={props.values.chestUnit}
											onBlur={handlerToCallStatisticsUpdateIfValid('chestUnit', 'chest')}
											onChange={props.store.setBinder('chestUnit')}
										/>
									</div>

								</React.Fragment>
							)
						}}
					</Form>
				</div>
			</section>
		)
	}
}

EditChest.contextTypes = {
	translate: PropTypes.func
}

EditChest.propTypes = {
	user: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	appBottomNavBarHandleClick: PropTypes.func.isRequired,
	appBottomNavBarLabelNext: PropTypes.func.isRequired,
	appHeading: PropTypes.func.isRequired,
	appShowBottomBar: PropTypes.func.isRequired,
	appShowBottomNavBar: PropTypes.func.isRequired,
	userProfileStatisticsUpdate: PropTypes.func.isRequired,
	history: PropTypes.shape({
		goBack: PropTypes.func.isRequired
	}).isRequired
}

export default connectPropTypes(EditChest)



// WEBPACK FOOTER //
// ./src/EditChest.jsx